type PasskeyCredentialConstructor = {
	new (...args: unknown[]): unknown;
	isConditionalMediationAvailable: () => Promise<boolean>;
};

type PasskeyGlobal = {
	PublicKeyCredential?: PasskeyCredentialConstructor | unknown;
};

const isPasskeyCredentialConstructor = (
	value: unknown,
): value is PasskeyCredentialConstructor =>
	typeof value === "function" &&
	typeof (value as PasskeyCredentialConstructor)
		.isConditionalMediationAvailable === "function";

export const isPasskeyConditionalUiAvailable = async (
	globalObject: PasskeyGlobal = globalThis,
) => {
	const publicKeyCredential = globalObject.PublicKeyCredential;
	if (!isPasskeyCredentialConstructor(publicKeyCredential)) {
		return false;
	}

	try {
		return await publicKeyCredential.isConditionalMediationAvailable();
	} catch {
		return false;
	}
};
